import { render } from "./AgencyWhatsAppConnections.vue?vue&type=template&id=42748fb1&scoped=true"
import script from "./AgencyWhatsAppConnections.vue?vue&type=script&lang=js"
export * from "./AgencyWhatsAppConnections.vue?vue&type=script&lang=js"

import "./AgencyWhatsAppConnections.vue?vue&type=style&index=0&id=42748fb1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42748fb1"]])

export default __exports__